module.exports = __webpack_public_path__ + "static/HeadzupSport_logo2-ca70ea1baa4fb4e73a725ee0f25aea00.png";